import "@/config/newrelic/bootstrap";
import "@/main.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@/config/i18n";
import config from "@/config";
import { LicenseInfo } from "@mui/x-license";

// https://mui.com/x/introduction/licensing/#license-key-security
// Prefer runtime config (App Config / Key Vault). Fallback keeps static envs
// (qa/sit/uat/prod) working until they inject mui.licenseKey or move to App Config.
if (config.mui?.licenseKey) {
  LicenseInfo.setLicenseKey(config.mui.licenseKey);
} else {
  LicenseInfo.setLicenseKey(
    "d9e522b4be238bf2b230989a6d6bee96Tz0xMjgyMjcsRT0xODA3ODMzNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y"
  );
}

function isPlaywrightMswControlling() {
  return Boolean(window.__PW_MSW__) || navigator.webdriver;
}

async function enableMocking() {
  if (!import.meta.env.DEV) {
    return;
  }

  if (isPlaywrightMswControlling()) {
    console.info("[MSW] skipping app worker (controlled by Playwright)");
    return;
  }

  const { worker, handlerList } = await import("./dev-mocks/browser");

  if (handlerList.length === 0) {
    console.info("[MSW] no handlers registered, skipping worker start");
    return;
  }

  // Ignore warnings of unhandled requests as default behavior is non mocked
  return worker.start({ onUnhandledFrame: "bypass" });
}

enableMocking().then(() => {
  const root = document.getElementById("root");
  if (!root) {
    throw new Error('Root element "#root" not found');
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
